import {
	IIncidentAgencySummary,
	IIncidentCategoryBreakdownFilters,
} from 'types/VehicleIncidents';
import { useGetDashboardBreakdownByAgencyQuery } from 'redux/api/vehicleIncidents';
import DashboardIncidentAgencyBreakdownCard from '../DashboardIncidentAgencyBreakdownCard';
import DashboardCard from '../DashboardCard';
import Heading from 'components/atoms/Heading';
import IncidentAgenciesAtAGlanceGraph from '../IncidentAgenciesAtAGlanceGraph';
import { firstDayOfLastJuly } from 'utils/firstDayOfLastJuly';
import { formatDate } from 'utils/formatDate';

export interface IDashboardIncidentsMainAgency {
	pdfRef: React.RefObject<HTMLDivElement>;
	renderingPdf: boolean;
}

const DashboardIncidentsMainAgency: React.FC<IDashboardIncidentsMainAgency> = ({
	pdfRef,
	renderingPdf,
}) => {
	const fromDate = firstDayOfLastJuly();
	const filters: IIncidentCategoryBreakdownFilters = {
		dateFrom: formatDate(fromDate),
	};
	const { data } = useGetDashboardBreakdownByAgencyQuery(filters);
	const agencies: IIncidentAgencySummary[] = data?.agencies || [];
	const graphAgencies = data?.graphAgencies || [];
	const renderClasses = renderingPdf ? '' : 'max-h-[600px] overflow-y-auto';

	return (
		<div className={`pt-6 ${renderingPdf ? '' : 'max-h-[700px]'}`} ref={pdfRef}>
			<Heading type="h3" className="mb-4 text-[24px]">
				All Agencies
			</Heading>
			<div className="flex space-x-[30px]">
				<div className="flex flex-col basis-2/5 min-w-[472px] items-stretch">
					<DashboardCard
						className={`basis-1/3 ${renderClasses} grow`}
						title="Incident Agencies"
						total={data?.total}
						dividerColor="border-grey-200"
					>
						<DashboardIncidentAgencyBreakdownCard
							agencies={agencies}
							getExtraFilters={() => {
								return { ...filters };
							}}
						/>
					</DashboardCard>
				</div>
				<div className="flex flex-col basis-3/5 min-w-[472px] items-stretch">
					<DashboardCard
						className="basis-2/3 max-h-[600px] min-h-[600px] overflow-y-auto"
						title="Agencies at a Glance"
						dividerColor="border-grey-200"
					>
						<IncidentAgenciesAtAGlanceGraph agencyData={graphAgencies} />
					</DashboardCard>
				</div>
			</div>
		</div>
	);
};

export default DashboardIncidentsMainAgency;
